module.exports = __webpack_public_path__ + "static/Zoom-778e01d7c5405cc7980b3da70dbd94d8.jpg";